import { render } from "./ResourceUploadDialog.vue?vue&type=template&id=fd73dbb2&scoped=true"
import script from "./ResourceUploadDialog.vue?vue&type=script&lang=js"
export * from "./ResourceUploadDialog.vue?vue&type=script&lang=js"

import "./ResourceUploadDialog.vue?vue&type=style&index=0&id=fd73dbb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd73dbb2"]])

export default __exports__